import {TaxAccountantConsultationModifyForm} from "@/features/manage";
import {vars} from "@/shared/lib";
import {Column} from "@/shared/ui";
import {createFileRoute} from "@tanstack/react-router";

export const Route = createFileRoute(
	"/(auth)/_layout/manage/tax-accountant-consultation/$taxAccountantConsultationId/modify"
)({
	component: TaxAccountantModify
});

function TaxAccountantModify() {
	return (
		<Column fullWidth style={{gap: vars.size[16]}}>
			<TaxAccountantConsultationModifyForm />
		</Column>
	);
}
